import { useEffect, useRef } from "react";
import { useAuth } from "../lib/auth";

export function SignInView() {
  const { googleConfigured, renderGoogleButton, signInWithGoogle, appleConfigured, signInWithApple } = useAuth();
  const btnRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // GIS script may load after mount; retry briefly until the button renders.
    if (!googleConfigured) return;
    let tries = 0;
    const id = setInterval(() => {
      tries += 1;
      if (btnRef.current) {
        btnRef.current.innerHTML = "";
        renderGoogleButton(btnRef.current);
      }
      if (tries > 20) clearInterval(id);
    }, 250);
    return () => clearInterval(id);
  }, [googleConfigured, renderGoogleButton]);

  return (
    <div className="flex h-full items-center justify-center bg-paper px-6">
      <div className="card w-full max-w-md p-10 text-center">
        <img src="/logo.png" alt="Cedar Post" className="mx-auto mb-6 h-20 w-20 rounded-2xl object-contain" />
        <h1 className="text-2xl font-bold text-ink">Cedar Post</h1>
        <p className="mt-2 text-sm text-muted">
          Your home projects, rooms, scans, and AI design ideas — on the big screen.
        </p>

        <div className="mt-8 flex flex-col items-center gap-3">
          {googleConfigured ? (
            <>
              <div ref={btnRef} />
              <button className="btn-ghost text-sm" onClick={signInWithGoogle}>
                Sign in with Google
              </button>
            </>
          ) : (
            <p className="rounded-card bg-cream px-4 py-3 text-sm text-muted">
              Google sign-in isn’t configured yet. Sign in with the same Google account you use in the app.
            </p>
          )}

          {appleConfigured && (
            <button
              className="flex w-[280px] items-center justify-center gap-2 rounded-full bg-black px-4 py-2.5 text-sm font-medium text-white transition hover:bg-black/85"
              onClick={signInWithApple}
            >
              <svg width="15" height="18" viewBox="0 0 14 17" fill="currentColor" aria-hidden="true">
                <path d="M11.6 9c0-1.6.9-2.5 1.2-2.8-.7-1-1.7-1.1-2.1-1.1-.9-.1-1.7.5-2.2.5-.5 0-1.2-.5-2-.5-1 0-2 .6-2.5 1.5-1.1 1.9-.3 4.6.8 6.1.5.7 1.1 1.5 1.9 1.5.8 0 1-.5 2-.5s1.1.5 2 .5c.8 0 1.3-.7 1.8-1.4.6-.8.8-1.6.8-1.6s-1.6-.6-1.6-2.7zM10 3.8c.4-.5.7-1.2.6-1.9-.6 0-1.3.4-1.7.9-.4.4-.7 1.1-.6 1.8.6 0 1.3-.3 1.7-.8z"/>
              </svg>
              Sign in with Apple
            </button>
          )}
        </div>

        <p className="mt-8 text-xs text-muted/70">
          Signs in with the same account as the AI Home Decorator app.
        </p>
      </div>
    </div>
  );
}
